import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putDocumentCategory = (
    token: string,
    backend: string,
    id: string,
    Name: string,
) => {
    return fetch(
        `${getApiUrl(backend)}edit_document_category/${id}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Name
            })
        }
    );
};

export default putDocumentCategory